import { render, staticRenderFns } from "./flexi_screenlet.vue?vue&type=template&id=2061faa1"
import script from "./flexi_screenlet.vue?vue&type=script&lang=js"
export * from "./flexi_screenlet.vue?vue&type=script&lang=js"
import style0 from "./flexi_screenlet.vue?vue&type=style&index=0&id=2061faa1&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports